import { getItem, removeItem, setItem } from "Common/localStorage/utils";
import { security } from "Common/permissions";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import { localStorageCopyGraphKey } from "../../constants";
const userId = security.getCurrentUserId();
const THREE_HOURS = 3 * 60 * 60 * 1000;
export const clearLocalStorage = () => {
    removeItem(localStorageCopyGraphKey);
};
export const setToLocalStorage = (data) => {
    setItem(localStorageCopyGraphKey, {
        data,
        userId,
        timestamp: new Date().getTime()
    });
};
export const getFromLocalStorage = () => {
    var _a;
    const localStorageData = getItem(localStorageCopyGraphKey);
    if (!localStorageData ||
        !isNumber(localStorageData.timestamp) ||
        !isObject(localStorageData.data) ||
        userId !== localStorageData.userId)
        return undefined;
    const localStorageTimeAgo = new Date().getTime() - localStorageData.timestamp;
    if (localStorageTimeAgo > THREE_HOURS || !isNumber((_a = localStorageData.data) === null || _a === void 0 ? void 0 : _a.FromDocumentId)) {
        clearLocalStorage();
        return undefined;
    }
    return localStorageData.data;
};
